import { render, staticRenderFns } from "./EmployeeWorkerOpportunityTable.vue?vue&type=template&id=c887dc4c&scoped=true&"
import script from "./EmployeeWorkerOpportunityTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkerOpportunityTable.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkerOpportunityTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmployeeWorkerOpportunityTable.vue?vue&type=style&index=1&id=c887dc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c887dc4c",
  null
  
)

export default component.exports